type ErrorResponse = {
    is_rdt_err: boolean;
    rdt_code?: string;
    error: string;
    data?: unknown;
};
export const isRdtErrorResponse = (response: unknown): response is ErrorResponse =>
    response != null &&
    typeof response === 'object' &&
    'is_rdt_err' in response &&
    'error' in response;
